import axios from 'axios';
import { getToken } from '../common/utils';
import { toast } from 'react-toastify';

const proxy = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api'
});

// Example: Set Authorization header if token exists
proxy.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
    }, (error) => {
    return Promise.reject(error);
});

// Response Interceptor: only force logout on auth failures (401), not permission denials (403)
proxy.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const hadSession = !!getToken();
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            // Only nudge users who actually had a session (avoid noise on public pages)
            if (hadSession) {
                toast.error('Session expired. Please log in again.');
                setTimeout(() => {
                    window.location.href = '/';
                }, 1500);
            }
        } else if (error.response?.status === 403) {
            toast.error(error.response?.data?.message || 'Access denied. You do not have permission.');
        }

        return Promise.reject(error);
    }
);

export default proxy;
